import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import React, { useState } from "react";
import { css } from "styled-components";

/* Poolcorp Custom Code */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useAnalytics } from "@store/Hooks/Common";
import useCurrentPage from "@store/Hooks/Common/useCurrentPage";
import useCurrentCurrency from "@store/Hooks/Context/useCurrentCurrency";
import useIsSearchPage from "@store/Hooks/ProductList/useIsSearchPage";
import { useIsCategoryPage } from "@store/Pages/ProductList/Hooks";
import { focusStyles, productImageStyles as productImageStylesMixin } from "@store/theme/common/mixins";
import { COMMON } from "@store/theme/design";
import { connect } from "react-redux";
/* Poolcorp Custom Code */

interface OwnProps {
    product: CartLineModel | ProductContextModel;
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: ProductImageStyles;
    showSmallImage?: boolean;
    // Poolcorp Custom Code
    imagePath?: string;
    hideLink?: boolean;
}

/* Poolcorp Custom Code */
const mapStateToProps = (state: ApplicationState) => {
    return {
        state,
    };
};
/* Poolcorp Custom Code */

type Props = OwnProps & ReturnType<typeof mapStateToProps>; // Poolcorp Custom Code

export interface ProductImageStyles {
    linkWrappingImage?: ClickablePresentationProps;
    /**
     * @deprecated Use img instead
     */
    image?: LazyImageProps;
    img?: ImgProps;
    // Poolcorp Custom Code
    wrapper?: InjectableCss;
}

export const productImageStyles: ProductImageStyles = {
    linkWrappingImage: {
        css: css`
            ${productImageStylesMixin()}
            ${focusStyles()}
            width: 100%;
        `,
    },
    image: {},
    img: {
        css: css`
            height: auto;
            width: 100%;
        `,
    },
    wrapper: {
        css: css`
            width: 100%;

            > span {
                cursor: default;
            }
        `,
    },
};


const ProductImage = ({
    product,
    onClick,
    extendedStyles,
    showSmallImage,
    // Poolcorp Custom Code
    imagePath,
    hideLink,
    state,
}: Props) => {
    const [styles] = useState(() => mergeToNew(productImageStyles, extendedStyles));

    /* Poolcorp Custom Code */
    const { dispatchProductClickEvent } = useAnalytics();
    const currentPage = useCurrentPage();
    const isSearchPage = useIsSearchPage();
    const isCategoryPage = useIsCategoryPage();
    const history = useHistory();
    const currentCurency = useCurrentCurrency() || undefined;
    const handleAnalyticsClick = () => {
        if ("product" in product) {
            dispatchProductClickEvent(product as ProductContextModel, 1, currentPage, isCategoryPage, isSearchPage, currentCurency?.currencyCode);
            return;
        }
        if (product) {
            dispatchProductClickEvent(product, 1, currentPage, isCategoryPage, isSearchPage, currentCurency?.currencyCode);
        }
    };
    /* Poolcorp Custom Code */

    let altText = "product" in product ? product.product.imageAltText : product.altText;
    if (!altText || altText === "") {
        altText = "product" in product ? product.product.productTitle : product.productName;
    }

    /* Poolcorp Custom Code */
    const path =
        imagePath ||
        ("product" in product
            ? showSmallImage
                ? product.product.smallImagePath || product.product.mediumImagePath
                : product.product.smallImagePath
            : product.smallImagePath || product.properties.smallImagePath || (product as any).mediumImagePath) ||
        COMMON.defaultProductImagePath;
    const isDefaultPath = path === COMMON.defaultProductImagePath;

    const onClickImage = (event: React.MouseEvent<Element, MouseEvent>) => {
        event.preventDefault();
        onClick?.(event);

        if (!productDetailPath) {
            return;
        }
        handleAnalyticsClick();

        if (productDetailPath.startsWith("http")) {
            window.location.href = productDetailPath;
        } else {
            history.push(productDetailPath);
        }

        return false;
    };
    /* Poolcorp Custom Code */

    const productDetailPath = "product" in product ? product.productInfo.productDetailPath : product.productUri;
    const loading = product.idx === undefined ? "lazy" : product.idx < 3 ? "eager" : "lazy";
    const href = hideLink ? undefined : productDetailPath; // Poolcorp Custom Code

    return (
        <StyledWrapper {...styles.wrapper}>
            <Clickable
                {...styles.linkWrappingImage}
                href={href /* Poolcorp Custom Code */}
                data-test-selector="productImage"
                onClick={onClickImage} // Poolcorp Custom Code
            >
                <Img
                    {...styles.img}
                    loading={loading}
                    src={path}
                    altText={!isDefaultPath ? altText : translate("Image Unavailable")} // Poolcorp Custom Code
                />
            </Clickable>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(ProductImage); // Poolcorp Custom Code
